import { queryCache } from 'react-query';
import { portalQueryCache } from './PortalQueryCache';
import { portalAccess } from './PortalAccess';

let generation = 0;
let profile = null;
const pending = new Set();
export const portalGeneration = () => generation;
export const resetPortalSession = (user = null) => {
  generation += 1;
  profile = user;
  pending.forEach((controller) => controller.abort());
  pending.clear();
  queryCache.clear();
  portalQueryCache.clear();
};
export const requirePortalAccess = (driverId) => {
  const access = portalAccess(profile);
  if (!access.dispatcher && !(access.driver && driverId != null && String(driverId) === access.id)) {
    throw Object.assign(new Error('Access denied'), { status: 403 });
  }
  return access;
};
export const sessionRequest = async (request, signal) => {
  const version = generation;
  const controller = new AbortController();
  const abort = () => controller.abort();
  pending.add(controller);
  if (signal?.aborted) abort();
  else if (signal) signal.addEventListener('abort', abort);
  try {
    const value = await request(controller.signal);
    if (version !== generation || controller.signal.aborted) {
      throw Object.assign(new Error('Session request cancelled'), { name: 'AbortError' });
    }
    return value;
  } finally {
    pending.delete(controller);
    if (signal) signal.removeEventListener('abort', abort);
  }
};

const transitions = [
  'signInRequest', 'meRequest', 'initialLoadRequest', 'logoutRequest',
  'signInSuccess', 'meSuccess', 'initialLoadSuccess', 'logoutSuccess',
  'initialLoadUnauthenticated', 'error',
].map((name) => `user/${name}`);

export const portalIdentityMiddleware = () => (next) => (action) => {
  if (transitions.includes(action.type)) resetPortalSession(action.payload?.user || null);
  return next(action);
};
